import { getEntitySourceLocation } from '@backstage/catalog-model';
import frontMatter from 'front-matter';
import { DateTime } from 'luxon';

const ANNOTATION_ADR_LOCATION = "backstage.io/adr-location";
const MADR_DATE_FORMAT = "yyyy-MM-dd";
const getAdrLocationDir = (entity) => {
  var _a, _b;
  return (_b = (_a = entity.metadata.annotations) == null ? void 0 : _a[ANNOTATION_ADR_LOCATION]) == null ? void 0 : _b.trim();
};
const isAdrAvailable = (entity) => Boolean(getAdrLocationDir(entity));
const getAdrLocationUrl = (entity, scmIntegration) => {
  if (!isAdrAvailable(entity)) {
    throw new Error(`Missing ADR annotation: ${ANNOTATION_ADR_LOCATION}`);
  }
  return scmIntegration.resolveUrl({
    url: getAdrLocationDir(entity),
    base: getEntitySourceLocation(entity).target
  });
};
const madrFilePathFilter = (path) => /^(?:.*\/)?\d{4}-.+\.md$/.test(path);
const parseMadrWithFrontmatter = (content) => {
  const parsed = frontMatter(content);
  const status = parsed.attributes.status;
  const date = parsed.attributes.date;
  const luxdate = DateTime.fromJSDate(/* @__PURE__ */ new Date(`${date}`));
  const formattedDate = luxdate.toISODate();
  return {
    content: parsed.body,
    status: status ? String(status) : void 0,
    date: date ? String(formattedDate) : void 0,
    attributes: parsed.attributes
  };
};

export { ANNOTATION_ADR_LOCATION, MADR_DATE_FORMAT, getAdrLocationUrl, isAdrAvailable, madrFilePathFilter, parseMadrWithFrontmatter };
//# sourceMappingURL=index.esm.js.map
